import { useRouteError } from 'react-router';
import { ThemeProvider } from 'styled-components';
import GlobalStyle from '/shared/styled/GlobalStyle/GlobalStyleTest';
import { colourTheme } from '/shared/styled/Colours';

import PageError from '/shared/components/PageError';
import { developmentMode } from '/shared/util/Statics';

const errorBoundaryTheme = {
  Colours: colourTheme,
  isDebug: false,
  target: {
    isConsumer: false,
    isBusiness: false,
    isCMPMain: false,
    isAirbp: false,
    value: '',
    hotjarUid: '',
  },
};

function ErrorRouteBoundary() {
  const routeError = useRouteError();
  const error =
    routeError === null || routeError === undefined || typeof routeError === 'string' || typeof routeError === 'object'
      ? routeError
      : String(routeError);

  return (
    <ThemeProvider theme={errorBoundaryTheme}>
      <GlobalStyle />
      <PageError error={developmentMode ? error : null} />
    </ThemeProvider>
  );
}
export default ErrorRouteBoundary;
